import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { createAppAction } from "../action/createAppAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
  successfull: false,
};

const opsIndCreateAppSlice = createSlice({
  name: "opsIndCreateAppSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createAppAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAppAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DATA createAppSlice", action);
      })
      .addCase(createAppAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const createAppReducer = opsIndCreateAppSlice.reducer;
